import {Types} from "../actions/webinarActions";
import _ from "lodash";
import ReactPixel from 'react-facebook-pixel';

import cleanDeep from 'clean-deep';


const defaultState = {
  leave: {}
};

const webinarReducers = (state = defaultState, action) => {
  switch (action.type) {
    case Types.WEBINAR_EVENTS_LOADED: {
      let newState = _.cloneDeep(state);
      newState.webinars.list = action.payload;
      return newState;
    }

    default:
      return state;
  }
};

export default webinarReducers;